import React from 'react';
import ReactDOM from 'react-dom/client';
import 'translations/i18n';
import App from 'components/App';
import { metaEnv } from 'utils/metaEnv';
import rg4js from 'raygun4js';
import '@fontsource/inter';
import '@fontsource/inter/500.css';
import '@fontsource/inter/700.css';
import '@fontsource/roboto-mono';
import 'shared/stylings/base/main.css';

const isRemote = metaEnv.MODE === 'production'; // non-local/remote env

rg4js('options', {
    apiEndpoint: '/raygun',
    disableAnonymousUserTracking: true,
    ignore3rdPartyErrors: true,
    excludedUserAgents: [/QA Automation/],
});
rg4js('setVersion', metaEnv.VITE_UI_VERSION || 'No version or vagrant');
const raygunApiKeyMeta = document.head.querySelector<HTMLMetaElement>(
    'meta[name="raygun-apiKey"]'
);
if (raygunApiKeyMeta) {
    rg4js('apiKey', raygunApiKeyMeta.content);
} else {
    console.warn('Missing Raygun API key!');
}
rg4js('enableCrashReporting', isRemote);
// replacing enablePulse as it's getting deprecated
rg4js('enableRealUserMonitoring', isRemote);
rg4js('saveIfOffline', true);

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// eslint-disable-next-line no-console
console.log(`HEAD commit: ${metaEnv.VITE_HEAD_COMMIT}`);
